// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15cvx","questions":"styles_questions__zB_gm","footer":"styles_footer__3X00V"};